import { Component, OnInit } from '@angular/core';
import { faqs } from '@shared/data/shared-data/shared-data';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  localFaqs = faqs;
  aboutTestimonial = [
    {
      img: 'assets/images/shared/testemonials/avatar1.jpg',
      text: `עם עודד הטבע נפרש כמניפה של תגליות וחידות, אפילו בפשוטים שבמקומות (- הוא עשה את זה עם ברוש שאני מכירה כל החיים ומעולם לא נתתי דעתי על זה שהוא מפותל ולמה) - מתגלים לילדים סודות ורזים, שהם לימדו את חלקם לנו, ההורים, בסיור סיום.
      הערוּת הזאת, הקשב הרב-חושי לטבע, מחלחל גם פנימה, לטבע שבכ"א מהם, ומורה להם את הדרך.
      פשוט קסום.`,
      name: 'יעל זליגמן',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar2.jpg',
      text: 'הייתה סדנא אדירה! לנסות בעצמי להתחקות כמה מאות מטרים אחר עקבות של צבי ושל חזיר בר במטרה להגיע לחיה הייתה חוויה מאתגרת ומרגשת ',
      name: ' רועי רוסטמי',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar4.jpg',
      text: `עודד איש שטח בכל רמ"ח אבריו.
      סוחף אחריו את הילדים ואת הוריהם לתוך עולם הגששות.`,
      name: 'יואב וקנין',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar3.jpg',
      text: `איש שטח בכל רמ"ח אבריו ומדריך בחסד! מנוסה, בעל ידע עצום, אדיב וסבלן, ועושה את עבודתו מתוך אהבה אמיתית! פשוט תענוג! אשרייך`,
      name: 'איתמר ברקאי',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar4.jpg',
      text: `היינו עם הילדים בסדנת גששות שעודד העביר, הייתה חוויה מאוד מיוחדת והילדים נהנו בטירוף!
      עודד היה מדהים עם הילדים, הם הלכו אחריו מוקסמים. גם אנחנו ההורים מאוד נהנינו מהידע והניסיון.
      מומלץ בחום!`,
      name: 'אילה הולנד',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar1.jpg',
      text: `חוויה ייחודית ומדהימה. עודד יודע לחבר את הגדולים והקטנים אל הטבע, מעורר מחשבה ואת הרצון לחקור ולחפש את בעלי החיים מסביבנו. טיול משפחות באווירה נעימה, מתאים למגוון רחב של גילאים`,
      name: 'סיגל קרופניק',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar2.jpg',
      text: `בעזרת אהבה רבה לטבע, ידע ואווירה כיפית ומשוחררת הסדנא של "גששות-בעקבות הטבע" הייתה דרך נהדרת לברוח מהעיר, להתחבר בחזרה לטבע ולגלות עולם שלם של חיות וחיים
      חוויה אמיתית ...ממליץ בחום
      `,
      name: 'רועי פינקלמן',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar3.jpg',
      text: `עודד חי ונושם טבע. איש שטח אמיתי, תמיד כייף לטייל איתו וללמוד ממנו. ממליץ בחום!!`,
      name: 'עמית גולדברג',
      roll: ''
    },
  ];

  employees = [
    {
      img: 'assets/images/shared/avatar6.jpg',
      name: 'עודד דוידוביץ',
      job: 'מורה דרך'
    },
    {
      img: 'assets/images/shared/avatar3.jpg',
      name: 'רוקי',
      job: 'גשש'
    },
    {
      img: 'assets/images/shared/avatar5.jpg',
      name: 'עינת דוידוביץ',
      job: 'שירות לקוחות'
    },
    {
      img: 'assets/images/shared/avatar4.jpg',
      name: 'מירב כהן',
      job: 'מדריכה ונהגת'
    }
  ];

  aboutTestimonialCarouselOptions = {
    items: 1,
    margin: 0,
    autoHeight: true,
    nav: true,
    dots: false,
    navText: ['<img src="assets/images/shared/left.png">', '<img src="assets/images/shared/right.png">'],
    autoplay: true,
    autoplayTimeout: 10000,
    slideSpeed: 12000,
    paginationSpeed: 5000,
    loop: true
  };

  aboutusData = `
  שמי עודד דוידוביץ, מאז ומתמיד אהבתי להיות בטבע.גרתי באזור מוקף פרדסים , גבעות ושלוליות חורף ושם ביליתי את רוב ילדותי, משוטט, משתולל , מטפס על עצים ואוכל תפוזים מהעצים. שם התעצב החיבור העמוק שלי לטבע ונצרבו בי רגעים מרגשים של מפגשים מפתיעים עם בעלי חיים שונים כמו התנשמת שעפה מעליי והעתיקה את נשמתי, נחשים, קרפדות ,ארנבות , שועלים ואפילו צבי שראיתי מרחוק ולא הייתי בטוח האם אני חולם או לא. הרגעים הקסומים האלה חרוטים בזיכרוני ואני נושא אותם איתי עד היום. התחושות האלו כל כך מיוחדות עבורי ואלו התחושות שאני רוצה להעביר לאנשים אחרים שמגששים איתי. ליצור יחד חיבור שורשי וקדמוני לטבע, הטבע שמשתנה כל הזמן ומצליח לרגש ולהפתיע אותי כל פעם מחדש.
מגיל צעיר הוקסמתי לקרוא ולשמוע סיפורים נפלאים על גששים בארץ ובעולם ויכולות הגישוש המיוחדות שלהם. בהמשך התחלתי לקרוא כל מה שאפשר בתחום, במקביל להתנסות סדורה יותר בשטח עם חברים וגם לבד.
 רגע משמעותי במיוחד היה כאשר השתתפתי בקורס גששות בדרום אפריקה ופגשתי את אחד הגששים הטובים בתחום-קולין פטריק-שם נחשפתי לגששות כדרך חיים וכמקצוע כמו גם להבנה שזה עולם ומלואו . לאחר חוויה זו הקמתי בשנת 2014 את "גששות-בעקבות הטבע" מתוך תשוקה עמוקה לחקר ולימוד של אומנות הגששות ומתוך רצון עז לשתף ולהעביר הלאה את הידע הייחודי הזה, ידע שלאורך השנים כמעט נעלם מעולמנו. לאחר שנים של הדרכות בטבע במסגרות שונות בתחומי הסיירות והאתגר ובתפקידי ניהול בתחום החינוך הבלתי פורמאלי, התמקצעתי בעשור האחרון בלימודי הגששות במקומות שונים בארץ ובעולם כגון: בלגיה, בריטניה, ארצות הברית ובדגש מיוחד על דרום אפריקה. 
לאורך השנים צברתי מאות שעות הדרכה של קבוצות שונות ברמות שונות ובגילאים שונים ואפילו סגרתי מעגל כאשר הדרכתי גששים מקומיים בדרום אפריקה ,היכן שהתחלתי ללמוד את אומנות הגששות. בנוסף הייתה לי הזכות להצטרף ולעזור לצוותי גששים שנלחמים יום יום בציד הלא חוקי של קרנפים, עבודה חשובה זו יכולה להיות סיזיפית לעיתים אך טומנת בחובה גם לא מעט סיפוק, הרפתקאות ואף סכנות
 בעל תואר שני בעבודה סוציאלית מאוניברסיטת בן גוריון ותעודת הנחיית קבוצות עם התמחות בטבעתרפיה. גשש מקצועי בארגון סייבר טרקר העולמי
 (גשש דרגה 4 בגששות עקבות וסימנים ובגששות מעקב)

  `;
  constructor() { }

  ngOnInit() { }
}
